module.exports = __webpack_public_path__ + "assets-cabinet/img/delete.35d39dc2.svg";